// src/components/SharedUI.js
import React from 'react';
import { X, Check, Play, FileText, FileDown } from 'lucide-react';

export const Card = ({ children, className = '' }) => (
  <div className={`bg-white rounded-2xl shadow-sm border border-slate-200 ${className}`}>
    {children}
  </div>
);

export const Badge = ({ children, variant = 'default', className = '' }) => {
  const variants = {
    default: 'bg-slate-100 text-slate-600 border-slate-200',
    success: 'bg-green-100 text-green-700 border-green-200',
    warning: 'bg-amber-100 text-amber-700 border-amber-200',
    brand: 'bg-red-50 text-red-700 border-red-200',
    info: 'bg-blue-50 text-blue-700 border-blue-200'
  };
  return (
    <span className={`text-xs font-bold px-2.5 py-0.5 rounded border ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
};

export const Toast = ({ visible, message, type }) => {
  if (!visible) return null;
  const isError = type === 'error';
  return (
    <div className={`fixed bottom-4 right-4 z-50 flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg text-white font-medium animate-[slideInRight_0.3s_ease-out] ${isError ? 'bg-red-600' : 'bg-slate-900 border-l-4 border-green-500'}`}>
      {isError ? <X size={18} /> : <Check size={18} className="text-green-500" />}
      {message}
    </div>
  );
};

export const MediaPreviewModal = ({ item, onClose }) => {
  if (!item) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/95 z-50 flex flex-col backdrop-blur-sm animate-[fadeIn_0.2s_ease-out]">
      <div className="p-4 flex justify-between items-center bg-slate-900/80 text-white border-b border-slate-800">
        <h3 className="font-bold text-lg">{item.title}</h3>
        <button onClick={onClose} className="p-2 text-slate-400 hover:text-white transition-colors bg-slate-800 rounded-full">
          <X size={20} />
        </button>
      </div>
      <div className="flex-1 p-8 flex items-center justify-center overflow-hidden">
        {item.type === 'photo' && (
          <img
            src={`https://placehold.co/1200x800/e2e8f0/64748b?text=Preview:+${encodeURIComponent(item.title)}`}
            alt={item.title}
            className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
          />
        )}

        {item.type === 'video' && (
          <div className="w-full max-w-4xl aspect-video bg-black/80 rounded-2xl flex flex-col items-center justify-center text-white relative shadow-2xl border border-slate-700">
            <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-red-500 transition-colors shadow-lg">
              <Play size={40} className="ml-2" />
            </div>
            <p className="mt-6 text-slate-400 font-medium tracking-wide">Simulated Video Playback</p>
          </div>
        )}

        {item.type === 'document' && (
          <div className="w-full max-w-3xl h-full bg-slate-50 rounded-2xl flex flex-col items-center justify-center text-slate-800 p-8 text-center shadow-2xl">
            <div className="w-32 h-32 bg-white rounded-2xl shadow-sm flex items-center justify-center mb-6">
              <FileText size={64} className="text-red-500" />
            </div>
            <h4 className="text-2xl font-bold mb-2">{item.title}</h4>
            <p className="text-slate-500 mb-8 max-w-md">This is a simulated document preview.</p>
            <button className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-xl font-bold flex items-center gap-2">
              <FileDown size={20} /> Download File
            </button>
          </div>
        )}
      </div>
    </div>
  );
};